// Utilitários da tela de conversas de WhatsApp

export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  // Contatos LID (privacidade do WhatsApp) não têm telefone exposto
  if (phone.includes('@')) return '';
  const number = phone.replace(/^55/, '');
  if (number.length < 10) return phone;
  return `(${number.slice(0, 2)}) ${number.slice(2, 7)}-${number.slice(7)}`;
};

// Chave estável da conversa: chatLid do WhatsApp quando existe, senão o telefone
export const getChatKey = (chat) => chat?.chatKey || chat?.chatId || chat?.senderPhone || null;

// Melhor identificador para ENVIAR: telefone real conhecido, senão o lid
export const getSendTarget = (chat) => chat?.bestPhone || chat?.senderPhone || null;

// Administrador da plataforma? Mesma leitura da sessão feita em menu/Menu.js
// e sidebar/Sidebar.js (sessionData no localStorage).
export const isPlatformAdminSession = () => {
  try {
    const sessionData = localStorage.getItem('sessionData');
    if (!sessionData) return false;
    const session = JSON.parse(sessionData);
    return Boolean(session?.user?.isPlatformAdmin);
  } catch (error) {
    return false;
  }
};

// Rótulo de prévia na lista de conversas conforme o tipo da última mensagem
export const getChatPreview = (chat) => {
  switch ((chat.messageType || 'text').toLowerCase()) {
    case 'image': return chat.caption ? 'Foto: ' + chat.caption : 'Foto';
    case 'audio': return 'Áudio';
    case 'video': return chat.caption ? 'Vídeo: ' + chat.caption : 'Vídeo';
    case 'document': return chat.fileName ? 'Documento: ' + chat.fileName : 'Documento';
    case 'sticker': return 'Figurinha';
    default: {
      const text = chat.messageText || chat.caption || '';
      return text.length > 34 ? text.substring(0, 34) + '…' : text;
    }
  }
};

export const formatTime = (date) => {
  const d = new Date(date);
  return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
};

// "Hoje", "Ontem" ou dd/mm/aaaa — usado nos separadores de data e na lista
export const formatDayLabel = (date) => {
  const d = new Date(date);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  if (d.toDateString() === today.toDateString()) return 'Hoje';
  if (d.toDateString() === yesterday.toDateString()) return 'Ontem';
  return d.toLocaleDateString('pt-BR');
};

// Na lista de chats: hora se for hoje, "Ontem", ou data curta
export const formatChatTimestamp = (date) => {
  const label = formatDayLabel(date);
  if (label === 'Hoje') return formatTime(date);
  return label;
};
